"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const cast_1 = require("../../../utilites/cast");
const AWSource_1 = require("./AWSource");
const Resolution_1 = require("../../basic/Resolution");
class AWSourceVisual extends AWSource_1.AWSource {
    constructor(type) {
        super(type);
        this.resolution = null;
        this.pixelAspectRatio = 0;
        this.colorDepth = 0;
        this.colorProfile = '';
    }
}
exports.AWSourceVisual = AWSourceVisual;
AWSourceVisual.propFactory = Object.assign(Object.assign({}, AWSource_1.AWSource.propFactory), { resolution: (object) => cast_1.castToType(object, Resolution_1.Resolution) });
